import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";

// Comps
import GraphChart from "../../components/Graph";

const LccGraph = () => {
  const [dynamicWidth, setDynamicWidth] = useState("200px");
  const graphData = useSelector((state) => state.graph.dataset);
  console.log(graphData, "graphData");

  // nivo bar
  const { nivoData, nivoKeys } = useMemo(() => {
    // x-axis categories
    let category = [];
    if (
      graphData &&
      graphData.length &&
      graphData[0].data &&
      graphData[0].data.length
    ) {
      if (graphData[0].data.length < 3) {
        category = [
          { label: "optimal" },
          { label: "current on-screen selection" },
        ];
      } else {
        category = [
          { label: "optimal" },
          { label: "optimal for existing configuration" },
          { label: "current on-screen selection" },
        ];
      }
    }

    const xLabels = category.map((cat) => cat.label);

    // nivo keys: one per stacked series
    const series = (graphData ?? [])
      .map((s) => ({
        key: s.seriesname ?? s.name ?? s.label ?? "unknown",
        color: s.data?.[0]?.color,
        data: s.data ?? [],
      }))
      .reverse(); // keep your legend/order logic similar

    const nivoKeys = series.map((s) => s.key);

    // nivo data rows
    const nivoData = xLabels.map((x, idx) => {
      const row = {x};
      for (const s of series){
        const v = s.data?.[idx]?.value;
        row[s.key] = v == null ? 0 : Number(v);
      }
      return row;
    });

    return { nivoData, nivoKeys };

  }, [graphData]);

  // cost color
  const groupColors = useMemo(() => {
    const entries =
      (graphData ?? []).map((s) => [
        s.seriesname,              // <-- adjust if your name field differs
        s.data?.[0]?.color,
      ]);

    return Object.fromEntries(entries.filter(([, c]) => !!c));
  }, [graphData]);

  useEffect(() => {
    setDynamicWidth("100%");
  }, []);

  return (
  <div>
    <GraphChart
      dynamicWidth={dynamicWidth}
      nivoData={nivoData}
      nivoKeys={nivoKeys}
      groupColors={groupColors}
    />
  </div>
  );
};

export default LccGraph;
